define('shared/initializer/form/adapters/CreditCardPayment',[
    'shared/initializer/form/constants',
    '$',
    './Payment',
    './mixins/fields/CreditCardName',
    './mixins/fields/CCV',
    './mixins/Returnable',
    './mixins/upsell/CardPayment',
    'shared/lib/ctor'
],
function (
    constants,
    $,
    Payment,
    CreditCardNameField,
    CCVField,
    Returnable,
    UpsellCardPayment,
    ctor
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);
        me.prefillable = {
            fields: {
                firstName: constants.FIELD.CREDIT_CARD_FIRSTNAME,
                lastName: constants.FIELD.CREDIT_CARD_LASTNAME,
                fullName: constants.FIELD.CREDIT_CARD_FULLNAME
            }
        };
        me.mixin(
            UpsellCardPayment,
            Returnable,
            CreditCardNameField,
            CCVField
        );
    }).inherit(Payment);

    var p = Ctor.prototype;

    function calculateCreditCardType(ccNumber){
        // supported by Server for now: Visa, Amex, MasterCard

        var ccType = constants.CREDITCARDTYPE.Visa;
        if(!ccNumber || ccNumber.length < 4){
            return ccType;
        }

        ccNumber = ccNumber.replace(/\s/g, '');
        var firstTwo = ccNumber.substr(0, 2) >> 0;

        switch (firstTwo){
            case 34:
            case 37:
                ccType = constants.CREDITCARDTYPE.Amex; //American Express
                break;
            case 36:
                //ccType = ''; //Diners Club
                break;
            case 38:
                //ccType = ''; //Carte Blanche
                break;
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
                ccType = constants.CREDITCARDTYPE.MasterCard; //Master Card
                break;
            default:
                var firstFour = ccNumber.substr(0, 4) >> 0;
                switch(firstFour){
                    case 2014:
                    case 2149:
                        //ccType = ''; //EnRoute
                        break;
                    case 2131:
                    case 1800:
                        ccType = constants.CREDITCARDTYPE.JCB;
                        break;
                    case 6011:
                        //ccType = ''; //Discover
                        break;
                    default:
                        var firstThree = ccNumber.substr(0, 3) >> 0;
                        if(firstThree >= 300 && firstThree <= 305) {
                            //ccType = ''; //American Diners Club
                        }
                        else {
                            var firstOne = ccNumber.substr(0, 1) >> 0;
                            if(firstOne == 3){
                                ccType = constants.CREDITCARDTYPE.JCB;
                            }
                            else if(firstOne == 4){
                                ccType = constants.CREDITCARDTYPE.Visa;
                            }
                        }
                        break;
                }
                break;
        }

        return ccType;
    }

    p.doBeforeSubmit = function () {
        var me = this;
        var $form = me.$form;

        return Payment.prototype.doBeforeSubmit.apply(me, arguments)
            .then(function(){
                var $ccname = $form.find('input[name="' + constants.FIELD.CREDIT_CARD_FULLNAME + '"]');
                var $ccFirstName = $form.find('input[name="' + constants.FIELD.CREDIT_CARD_FIRSTNAME + '"]');
                var $ccLastName = $form.find('input[name="' + constants.FIELD.CREDIT_CARD_LASTNAME + '"]');

                if ($ccname.length > 0 && $ccFirstName.length > 0 && $ccLastName.length > 0) {
                    var tmp = $ccname.val().split(' ');
                    var firstName = tmp.shift();
                    var lastName = tmp.join(' ');

                    $ccFirstName.val( $.trim(firstName) );
                    $ccLastName.val( $.trim(lastName) );
                }
            })
            .then(function(){
                var ccNumber = $form.find('input[name="' + constants.FIELD.CREDIT_CARD_NUMBER + '"]').val();
                var ccType = calculateCreditCardType(ccNumber);
                $form.find('input[name="' + constants.FIELD.CREDIT_CARD_TYPE + '"]').val(ccType);
            });
    };

    return Ctor;
});

